import { jsx as o } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { TypographyElement as p, TypographyVariant as f } from "../Typography/types.js";
import g from "../../../core/Context/useCoreContext.js";
import { useTabbedControl as u } from "../../../hooks/useTabbedControl.js";
import y from "../Typography/Typography.js";
/* empty css                      */
function x({ defaultItem: i, items: a }) {
  const { activeIndex: t, onClick: l, onKeyDown: s, refs: c, uniqueId: n } = u(a, i), { i18n: m } = g();
  return /* @__PURE__ */ o("div", { children: [
    /* @__PURE__ */ o("div", { role: "radiogroup", className: "adyen-fp-segmented-control", children: a.map((e, r) => {
      const d = t === r;
      return /* @__PURE__ */ o(
        "button",
        {
          role: "radio",
          name: e.id,
          ref: c[r],
          id: `item:${n}-${e.id}`,
          className: "adyen-fp-segmented-control__item",
          "aria-checked": d,
          "aria-controls": `segment:${n}-${e.id}`,
          onClick: d ? void 0 : l,
          onKeyDown: s,
          disabled: e.disabled,
          tabIndex: d ? 0 : -1,
          children: /* @__PURE__ */ o(
            y,
            {
              el: p.SPAN,
              variant: f.BODY,
              className: "adyen-fp-segmented-control__item-label",
              stronger: !0,
              children: m.get(e.label)
            }
          )
        },
        `item:${n}-${e.id}`
      );
    }) }),
    /* @__PURE__ */ o("div", { className: "adyen-fp-segmented-content-container", children: a.map((e, r) => /* @__PURE__ */ o(
      "section",
      {
        id: `segment:${n}-${e.id}`,
        className: "adyen-fp-segmented-content",
        "aria-labelledby": `item:${n}-${e.id}`,
        hidden: t !== r,
        children: e.content
      },
      `segment:${n}-${e.id}`
    )) })
  ] });
}
export {
  x as default
};
